import {
    booleanCodec,
    dateRangeCodec,
    encodedArrayCodec,
    PresetSearchParamsCustomDefaultValues,
    TableRestoreConfig,
    withModeCodec,
} from "@impero-com/ui/domain";
import * as Sentry from "@sentry/react";

export const DASHBOARD_PENDING_ACTIVITIES_LOCAL_STORAGE_KEY =
    "dashboardPendingActivities";

export const DASHBOARD_PENDING_ACTIVITIES_LIST_COLUMN_IDS = {
    ACTION: "action",
    CONTROL_TITLE: "controlTitle",
    TAGS: "tags",
    PROGRAM_NAME: "controlProgramName",
    USER_POOL_NAME: "userPoolName",
    CLAIMANT_NAME: "claimantName",
    DUE_DATE: "dueDate",
    ENTITY: "entity",
    ENTITIES_TO_TEST: "entitiesToTest",
    TEST_PROGRAM: "testProgram",
} as const;

export const DASHBOARD_PENDING_ACTIVITIES_DATA_PARAM = {
    INCLUDE_CONTROL_ACTIVITIES: "includeControlActivities",
    INCLUDE_TESTING_ACTIVITIES: "includeTestingActivities",
} as const;

export const DASHBOARD_PENDING_ACTIVITIES_LIST_DEFAULT_STATE: PresetSearchParamsCustomDefaultValues =
    {
        sorting: [
            {
                id: DASHBOARD_PENDING_ACTIVITIES_LIST_COLUMN_IDS.DUE_DATE,
                desc: false,
            },
        ],
        columnOrder: [
            DASHBOARD_PENDING_ACTIVITIES_LIST_COLUMN_IDS.ACTION,
            DASHBOARD_PENDING_ACTIVITIES_LIST_COLUMN_IDS.CONTROL_TITLE,
            DASHBOARD_PENDING_ACTIVITIES_LIST_COLUMN_IDS.ENTITY,
            DASHBOARD_PENDING_ACTIVITIES_LIST_COLUMN_IDS.ENTITIES_TO_TEST,
            DASHBOARD_PENDING_ACTIVITIES_LIST_COLUMN_IDS.PROGRAM_NAME,
            DASHBOARD_PENDING_ACTIVITIES_LIST_COLUMN_IDS.TEST_PROGRAM,
            DASHBOARD_PENDING_ACTIVITIES_LIST_COLUMN_IDS.TAGS,
            DASHBOARD_PENDING_ACTIVITIES_LIST_COLUMN_IDS.USER_POOL_NAME,
            DASHBOARD_PENDING_ACTIVITIES_LIST_COLUMN_IDS.CLAIMANT_NAME,
            DASHBOARD_PENDING_ACTIVITIES_LIST_COLUMN_IDS.DUE_DATE,
        ],
        dataParams: {
            [DASHBOARD_PENDING_ACTIVITIES_DATA_PARAM.INCLUDE_CONTROL_ACTIVITIES]: true,
            [DASHBOARD_PENDING_ACTIVITIES_DATA_PARAM.INCLUDE_TESTING_ACTIVITIES]: true,
        },
    };

export const PENDING_ACTIVITIES_REDIRECT_SUFIX = "?redirect";

export const dashboardPendingActivityListColumnFiltersCodecMap = {
    [DASHBOARD_PENDING_ACTIVITIES_LIST_COLUMN_IDS.ACTION]:
        withModeCodec(encodedArrayCodec),
    [DASHBOARD_PENDING_ACTIVITIES_LIST_COLUMN_IDS.CONTROL_TITLE]:
        withModeCodec(encodedArrayCodec),
    [DASHBOARD_PENDING_ACTIVITIES_LIST_COLUMN_IDS.ENTITY]:
        withModeCodec(encodedArrayCodec),
    [DASHBOARD_PENDING_ACTIVITIES_LIST_COLUMN_IDS.PROGRAM_NAME]:
        withModeCodec(encodedArrayCodec),
    [DASHBOARD_PENDING_ACTIVITIES_LIST_COLUMN_IDS.TAGS]:
        withModeCodec(encodedArrayCodec),
    [DASHBOARD_PENDING_ACTIVITIES_LIST_COLUMN_IDS.USER_POOL_NAME]:
        withModeCodec(encodedArrayCodec),
    [DASHBOARD_PENDING_ACTIVITIES_LIST_COLUMN_IDS.CLAIMANT_NAME]:
        withModeCodec(encodedArrayCodec),
    [DASHBOARD_PENDING_ACTIVITIES_LIST_COLUMN_IDS.DUE_DATE]:
        withModeCodec(dateRangeCodec),
    [DASHBOARD_PENDING_ACTIVITIES_LIST_COLUMN_IDS.ENTITIES_TO_TEST]:
        withModeCodec(encodedArrayCodec),
    [DASHBOARD_PENDING_ACTIVITIES_LIST_COLUMN_IDS.TEST_PROGRAM]:
        withModeCodec(encodedArrayCodec),
};

export const dashboardPendingActivityListDataParamsCodecMap = {
    [DASHBOARD_PENDING_ACTIVITIES_DATA_PARAM.INCLUDE_CONTROL_ACTIVITIES]:
        booleanCodec,
    [DASHBOARD_PENDING_ACTIVITIES_DATA_PARAM.INCLUDE_TESTING_ACTIVITIES]:
        booleanCodec,
};

export const dashboardPendingActivitiesRestoreConfig: TableRestoreConfig = {
    tableId: DASHBOARD_PENDING_ACTIVITIES_LOCAL_STORAGE_KEY,
    defaultValues: DASHBOARD_PENDING_ACTIVITIES_LIST_DEFAULT_STATE,
    codecMap: dashboardPendingActivityListColumnFiltersCodecMap,
    dataParamsCodecMap: dashboardPendingActivityListDataParamsCodecMap,
    onError: Sentry.captureException,
};
